import React, { forwardRef } from "react";

import * as Select from "@radix-ui/react-select";
import {
  ChevronDown,
  Check,
  Search,
  PlusCircle,
  ClipboardList,
} from "lucide-react";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import { GoDatabase } from "react-icons/go";
import styles from "../Styles/ui/Breadcrumb.module.css";
import { Link } from "react-router-dom";
import HyphenviewLogo from "../../../assets/inventory_icons/hyphenview.png";

const Breadcrumb = forwardRef(
  ({ className, children, isOpen, toggleSidebar, ...props }, ref) => (
    <nav
      ref={ref}
      className={`${styles.navbar} ${className}`}
      aria-label="breadcrumb"
      {...props}
    >
      {!isOpen && (
        <button className={styles.floatingToggle} onClick={toggleSidebar}>
          <FaGreaterThan size={15} />
        </button>
      )}
      {/* <DatabaseDropdown /> */}

      <Link to="/inventory_dashboard" className={styles.breadcrumbLink}>
        <h1 className={styles.logoText}>Inventory</h1>
        {children}
      </Link>

      {isOpen && (
        <button className={styles.toggleButton} onClick={toggleSidebar}>
          <FaLessThan size={15} />
        </button>
      )}
    </nav>
  )
);

Breadcrumb.displayName = "Breadcrumb";

export { Breadcrumb };
